export default "__VITE_ASSET__Z8oafVlX__"